import type { CitationLink } from '../../content/marketing/faqContent';

interface CitationListProps {
  sources: CitationLink[];
  tone?: 'light' | 'dark';
  className?: string;
}

export function CitationList({
  sources,
  tone = 'light',
  className = '',
}: CitationListProps) {
  if (sources.length === 0) return null;

  const labelClass =
    tone === 'dark' ? 'text-alabaster/50' : 'text-sand';
  const linkClass =
    tone === 'dark'
      ? 'border-white/10 text-alabaster/75 hover:border-white/30 hover:text-alabaster'
      : 'border-stone text-charcoal/75 hover:border-olive/40 hover:text-charcoal';
  const noteClass = tone === 'dark' ? 'text-alabaster/45' : 'text-sand/80';

  return (
    <div className={`space-y-3 ${className}`}>
      <div className={`text-[11px] font-mono uppercase tracking-[0.24em] ${labelClass}`}>
        Sources
      </div>
      <div className="flex flex-wrap gap-2">
        {sources.map((source) => (
          <a
            key={source.url}
            href={source.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`rounded-full border px-3 py-1.5 text-xs font-light transition-colors ${linkClass}`}
          >
            {source.label}
          </a>
        ))}
      </div>
      {sources.some((source) => source.note) && (
        <div className={`text-xs font-light ${noteClass}`}>
          {sources
            .filter((source) => source.note)
            .map((source) => source.note)
            .join(' ')}
        </div>
      )}
    </div>
  );
}
